var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArrow = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 12 22"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M2.404 11 12 20.776 10.798 22 .601 11.612 0 11l.6-.612L10.799 0 12 1.224z"
})));
export default SvgArrow;